import { render } from "./totalProfitsFlights.vue?vue&type=template&id=5b390be9&scoped=true"
import script from "./totalProfitsFlights.vue?vue&type=script&lang=js"
export * from "./totalProfitsFlights.vue?vue&type=script&lang=js"

import "./totalProfitsFlights.vue?vue&type=style&index=0&id=5b390be9&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b390be9"]])

export default __exports__